import { render, staticRenderFns } from "./PlayTreasureHunt.vue?vue&type=template&id=0f898c66&scoped=true&"
import script from "./PlayTreasureHunt.vue?vue&type=script&lang=js&"
export * from "./PlayTreasureHunt.vue?vue&type=script&lang=js&"
import style0 from "./PlayTreasureHunt.vue?vue&type=style&index=0&id=0f898c66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f898c66",
  null
  
)

export default component.exports